import { createSlice } from '@reduxjs/toolkit'

import { UiState } from './types'

const INITIAL_STATE: UiState = {
  isCtmNumberReady: false
}

export const slice = createSlice({
  name: 'ui',
  initialState: INITIAL_STATE,

  reducers: {
    setCtmNumberReady: state => {
      state.isCtmNumberReady = true
    }
  }
})

export const { actions } = slice
export const uiReducer = slice.reducer
